import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { getFilterConfig } from '../config/filterConfig';

const OuvidoriaFilter = ({ loading, values, motivoOptions, tagOptions, onApply, onLimpar }) => {
  const filterConfig = useMemo(
    () =>
      getFilterConfig({
        motivoOptions,
        tagOptions,
      }),
    [motivoOptions, tagOptions]
  );

  return (
    <Row>
      <Col md={12}>
        <FilterPanel
          filters={filterConfig}
          values={values}
          onApply={onApply}
          onLimpar={onLimpar}
          title="Filtros de Ouvidoria"
          loading={loading}
          defaultCollapsed={true}
        />
      </Col>
    </Row>
  );
};

export default OuvidoriaFilter;
